import "./App.css";
import Login from "./pages/Login";
import { Route, Routes, Navigate } from "react-router-dom";
import { Home } from "./pages/Home";
import Confirmation from "./pages/Confirmation";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
      <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/*" element={<Home />} />
        </Routes>
    </>
  );
}

export default App;
